import { Invoice, InvoicePayload } from '../@types';

export const postInvoice = async (payload: InvoicePayload): Promise<number> => {
	const response = await fetch(`${process.env.REACT_APP_API_URL}/api/ProxiesV2/invoices`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${sessionStorage.getItem('token')}`,
			apikey: process.env.REACT_APP_APIKEY || '',
		},
		body: JSON.stringify(payload),
	});
	const json = await response.json().catch(() => ({}));

	if (!response.ok || json.error) {
		throw new Error(json?.error?.message || `Request failed: ${response.status}`);
	}

	return json.data;
};

export const patchInvoice = async (
	invoiceId: number,
	payload: Partial<InvoicePayload>
): Promise<Invoice> => {
	const response = await fetch(
		`${process.env.REACT_APP_API_URL}/api/ProxiesV2/invoices/${invoiceId}`,
		{
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${sessionStorage.getItem('token')}`,
				apikey: process.env.REACT_APP_APIKEY || '',
			},
			body: JSON.stringify(payload),
		}
	);

	const json = await response.json().catch(() => ({}));

	if (!response.ok) {
		throw new Error(json?.error?.message || `Request failed: ${response.status}`);
	}
	return json.data ?? json;
};

interface UploadInvoiceDocumentPayload {
	contractId: number;
	invoiceId?: number | null;
	file: File;
}

export const uploadInvoiceDocument = async ({
	contractId,
	invoiceId,
	file,
}: UploadInvoiceDocumentPayload): Promise<void> => {
	const token = sessionStorage.getItem('token');
	const formData = new FormData();

	formData.append('file', file, file.name);
	formData.append('contract', String(contractId));

	if (invoiceId != null) {
		formData.append('invoice', String(invoiceId));
	}

	const response = await fetch(`${process.env.REACT_APP_API_URL}/api/ProxiesV2/documents`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			apikey: process.env.REACT_APP_APIKEY || '',
		},
		body: formData,
	});

	const json = (await response.json().catch(() => ({}))) as {
		error?: { message?: string };
	};

	if (!response.ok || json.error) {
		throw new Error(json?.error?.message || `Request failed: ${response.status}`);
	}
};
